var SwiperTeam = {
    init:function(){
        var swiper = new Swiper(".block-team .swiper-container", {
            slidesPerView:'auto',
            spaceBetween: '11%',
            
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
            }
         });
    }
}

$(window).load(function(){
    if($('.block-team').length){
        SwiperTeam.init();
    }
})